import ProtectedSection, {
  type ProtectedSectionProps,
} from '../components/ProtectedSection';

export type ProtectedArticleGroupProps = ProtectedSectionProps;

/**
 * 글 본문에서 임의의 블록들을 **하나의 잠금 단위**로 묶습니다.
 * `ArticleTextSection`, `ArticleImageLayout`, 기타 JSX를 자식으로 원하는 범위만큼 넣으면 됩니다.
 * 비밀번호는 `lockPassword`로만 받으며, 같은 글의 `ProtectedPage` `password`와는 별도로 설정합니다.
 */
export function ProtectedArticleGroup(props: ProtectedArticleGroupProps) {
  return <ProtectedSection {...props} />;
}
